import { SITE_PAGES } from 'Config';
import BiobankDetailsView from 'Pages/Biobanks/BiobankDetailsView';
import BiobankLanding from 'Pages/Biobanks/BiobankLanding';
import PropTypes from 'prop-types';
import { getBreadcrumb } from 'Util';

const BiobankDetailsPage = ({ params }) => {
  let breadcrumbs = params?.id && [
    getBreadcrumb(SITE_PAGES.BIOBANK_LANDING),
    {
      icon: SITE_PAGES.BIOBANK_DETAIL.icon,
      text: params.id,
    },
  ];

  return (
    <BiobankLanding title='Manage Bio Resource Entry' breadcrumbs={breadcrumbs}>
      <BiobankDetailsView params={params} />
    </BiobankLanding>
  );
};

BiobankDetailsPage.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string }),
};

export default BiobankDetailsPage;
